import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteDynamicSection from '@/modules/client-setting/api/hooks/useMutationDeleteDynamicSection'
import { DynamicSectionQueryKeys } from '@/modules/client-setting/keys'

interface DeleteDynamicSectionModalProps {
	id: string
}

export default function DeleteDynamicSectionModal({
	id,
}: DeleteDynamicSectionModalProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteDynamicSection } = useMutationDeleteDynamicSection({
		onSuccess: () => {
			toast.success('ลบ section สำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [DynamicSectionQueryKeys.GetDynamicSection],
			})
		},
		onError: (error: any) => {
			if (
				error?.response?.data?.message ===
				'Cannot delete section that is being used in a page'
			) {
				showErrorToast(
					'ไม่สามารถลบ section ได้เนื่องจากกำลังถูกใช้งานในหน้าเพจ',
				)
			} else {
				showErrorToast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
			}
		},
	})

	const handleDelete = () => {
		deleteDynamicSection({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบ section</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบ section นี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
